import { useWindowDimensions } from 'react-native';

// Breakpoints from the designer's handoff (@media blocks in store.css / vault.css).
export const TABLET_MAX = 980;
export const PHONE_MAX = 640;

/**
 * Responsive layout for the Relic Vault overlay. The overlay is full-screen, so
 * the window width is the layout width.
 */
export function useRelicVaultLayout() {
  const { width, height } = useWindowDimensions();
  const isTablet = width <= TABLET_MAX;
  const isPhone = width <= PHONE_MAX;
  return { width, height, isTablet, isPhone };
}

/**
 * Column width for a flex-wrap grid that emulates
 * `grid-template-columns: repeat(columns, minmax(0, 1fr))` with `gap`.
 */
export function gridItemWidth(containerWidth, columns, gap) {
  if (!containerWidth || columns < 1) return 0;
  return Math.floor((containerWidth - gap * (columns - 1)) / columns);
}
